/* Shelving Racking Co - multipack price labels + selected-option specification (11-10-2026) + order line details (12-10-2026).
   On a multipack listing the price covers the whole pack and quantity 1 is one complete pack.
   sr-product.js writes the price basis line ("per unit · ..."); this file corrects its first part
   and adds a line under the quantity box. The pack size is read from a "Number of ..." /
   "Pack of N" option first (it can change per variant), then from the product title. */
(function () {
  var root = document.querySelector('[data-srp]');
  var jsonEl = document.querySelector('[data-srp-json]');
  if (!root || !jsonEl || root.__srpack) return;
  root.__srpack = true;
  var D; try { D = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  var T = D.title || '';
  var PART = /\bkit\b|wall ti|connector|additional|extra shel|\bshelf\b|\bbeams?\b|bracket|\bclips?\b/i.test(T);
  var SHELF = /shelving|racking|\bunit\b|\bbay\b/i.test(T) && !/trolley|truck|ladder|step|mat\b/i.test(T) && !PART;
  var BUNDLE = /&\s*1x\s|\bbundle\b/i.test(T);
  var m = /\bpack of\s*(\d+)|\bset of\s*(\d+)|\bbundle of\s*(\d+)|\b(\d+)[\s-]*pack\b|^\s*(\d+)\s*x\s/i.exec(T);
  var TITLE_N = m ? parseInt(m[1] || m[2] || m[3] || m[4] || m[5], 10) : 1;
  var IPK = -1;
  (D.options || []).forEach(function (o, i) {
    if (IPK < 0 && /^number of (?!treads|rungs|drawers|shelves|tool trays|assorted hooks|tote boxes)|connectors$|steel feet$/i.test(o)) IPK = i;
  });
  function current() {
    var idIn = root.querySelector('[data-srp-id]'), id = idIn ? parseInt(idIn.value, 10) : D.current;
    return (D.variants || []).filter(function (v) { return v.id === id; })[0] || (D.variants || [])[0];
  }
  function packOf(v) {
    if (IPK > -1 && v) {
      var s = String(v.o[IPK] || ''), a = /pack of\s*(\d+)/i.exec(s) || /^\s*(\d+)\s*$/.exec(s);
      if (a) return parseInt(a[1], 10);
    }
    return TITLE_N;
  }
  function word(n) {
    if (SHELF) return n > 1 ? 'units' : 'unit';
    if (IPK < 0) return n > 1 ? 'items' : 'item';
    var w = String(D.options[IPK]).replace(/^number of\s*/i, '').replace(/^.*\b(connectors|feet)$/i, '$1').toLowerCase();
    return w;
  }

  /* ---------- specification for the selected option (11-10-2026) ----------
     The description's own table lists every size the listing is sold in; this
     table shows the figures for the exact option chosen, and updates with it. */
  var UI = null; try { var uj = document.getElementById('srp-ui-json'); UI = uj ? JSON.parse(uj.textContent) : null; } catch (e) {}
  function oidx(re) { for (var i = 0; i < (D.options || []).length; i++) if (re.test(D.options[i])) return i; return -1; }
  function nnum(s) { var m = /(\d[\d,]*(?:\.\d+)?)/.exec(String(s || '')); return m ? parseFloat(m[1].replace(/,/g, '')) : null; }
  var OW = oidx(/width/i), OD = oidx(/depth/i), OL = oidx(/^(levels?|tiers?|decks?|number of (shelves|levels|decks))/i), OLD = oidx(/load per shelf|udl|load capacity per/i), OH = oidx(/height/i);
  var TH = /(\d{3,4})\s?mm\s*(?:high|height|tall)/i.exec(T);
  function fromUI(v, re) {
    if (!UI || !UI.b || !UI.x) return null;
    var key = v.o.filter(function (x) { return x != null; }).join('|'), idx = UI.x[key] || [];
    for (var i = 0; i < idx.length; i++) { var b = UI.b[idx[i]]; if (b && re.test(b.l) && b.it && b.it[0]) return b.it[0].t; }
    return null;
  }
  function kg(n) { return (n >= 1000 ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : String(n)) + 'kg'; }
  function specRows(v) {
    var r = [];
    var h = OH > -1 ? v.o[OH] : (TH ? TH[1] : null);
    if (h) r.push(['Height', String(h).replace(/mm$/i, '') + 'mm']);
    var LS = /longspan/i.test(T), bw = OW > -1 ? nnum(v.o[OW]) : null;
    if (LS && bw) {
      /* Longspan (11-10-2026): the width option is the beam width. Tufferman's spec table: external bay width = beam + 100mm
         (two 50mm upright frames), clear entry = beam - 10mm; an extension bay brings one frame, so it adds beam + 50mm. */
      r.push(['Beam width (selected)', bw + 'mm']);
      r.push(['External bay width (outside of uprights)', (bw + 100) + 'mm']);
      r.push(['Clear entry (usable opening)', (bw - 10) + 'mm']);
      if (/extension/i.test(T)) r.push(['Adds to an existing run', (bw + 50) + 'mm (shares one upright with the bay it joins)']);
    } else if (OW > -1) r.push(['Width', String(v.o[OW]).replace(/mm$/i, '') + (/^\d+$/.test(v.o[OW]) ? 'mm' : '')]);
    if (OD > -1) r.push(['Depth', String(v.o[OD]).replace(/mm$/i, '') + (/^\d+$/.test(v.o[OD]) ? 'mm' : '')]);
    var lv = OL > -1 ? nnum(v.o[OL]) : nnum(fromUI(v, /^levels/i));
    if (lv == null) { var ml = /(\d)\s*(?:levels?|tiers?)\b/i.exec(T); if (ml) lv = +ml[1]; }
    if (lv != null) r.push(['Levels', String(lv)]);
    var ld = OLD > -1 ? nnum(v.o[OLD]) : nnum(fromUI(v, /load per shelf|udl/i));
    if (ld != null) {
      r.push(['Load per shelf', kg(ld) + ' UDL']);
      if (lv != null && SHELF) r.push(['Total load (all levels)', kg(ld * lv) + ' UDL']);
    }
    var n = packOf(v);
    if (BUNDLE) r.push(['Supplied as', 'Complete bundle']);
    else if (n > 1) r.push(['Supplied as', 'Pack of ' + n + ' ' + word(n)]);
    return r;
  }
  var specBox = null;
  function drawSpec() {
    var v = current(); if (!v) return;
    var rows = specRows(v);
    if (rows.length < 2) { if (specBox) specBox.hidden = true; return; }
    if (!specBox) {
      var host = root.querySelector('.srp-desc .srp-w');
      if (!host) return;
      specBox = document.createElement('div');
      specBox.setAttribute('data-srp-selspec', '');
      specBox.style.cssText = 'margin:0 0 28px;max-width:640px';
      host.insertBefore(specBox, host.firstChild);
    }
    var lab = (v.t && !/default title/i.test(v.t)) ? v.t : '';
    specBox.hidden = false;
    specBox.innerHTML = '<h2 class="srp-h2" style="font-size:28px!important;margin:0 0 6px!important">Specification for your selected option</h2>' +
      '<p style="margin:0 0 12px;color:#56606E;font-size:15px">' + (lab ? 'Selected: ' + lab.replace(/[<>&]/g, '') + '. ' : '') + 'These figures change with the options you pick above. The description below covers every size this listing is sold in.</p>' +
      '<table style="width:100%;border-collapse:collapse;font-size:16.5px"><tbody>' +
      rows.map(function (x) { return '<tr><th style="text-align:left;padding:11px 14px;border-bottom:1px solid #E1E4E8;background:#F8F9FA;width:42%;font-weight:600">' + x[0] + '</th><td style="padding:11px 14px;border-bottom:1px solid #E1E4E8;font-weight:700">' + x[1] + '</td></tr>'; }).join('') +
      '</tbody></table>';
  }

  /* ---------- order details (12-10-2026) ----------
     Every choice the customer made travels with the basket line as line-item
     properties, so the cart, checkout, order e-mails and the Shopify order page
     all show it in words: Height / Width / Depth / Levels / Load / Colour /
     Qty of units / pack size, plus the supplier-style figures (beam width,
     external bay width, clear entry). Values are the same ones the page shows. */
  function mmv(name, val) { var s = String(val == null ? '' : val).trim(); return ((/\(mm\)/i.test(name) || /^(height|width|depth)\b/i.test(String(name || ''))) && /^\d+$/.test(s)) ? s + 'mm' : s; }
  function clean(l) { return String(l || '').replace(/\s*\(mm\)/i, '').replace(/\s*\(optional\)/i, '').replace(/:\s*$/, '').trim(); }
  function dkey(k) { return k.toLowerCase().replace(/\(.*?\)/g, '').replace(/[^a-z]/g, ''); }
  function orderProps(v) {
    var out = [], seen = {}, LS = /longspan/i.test(T);
    function put(k, val) { k = clean(k); if (!k || val == null || val === '') return; var d = dkey(k); if (seen[d]) return; seen[d] = 1; out.push([k, String(val)]); }
    var pri = [], sec = [];
    if (UI && UI.g) UI.g.forEach(function (g) { var on = (g.it || []).filter(function (i) { return i.on; })[0]; if (!on) return; (g.p ? pri : sec).push([g.l, mmv(g.l, on.v)]); });
    pri.forEach(function (x) { put(x[0], x[1]); });
    (D.options || []).forEach(function (o, i) { if (LS && /width/i.test(o)) return; put(o, mmv(o, v.o[i])); });
    specRows(v).forEach(function (r) { put(r[0], r[1]); });
    sec.forEach(function (x) { put(x[0], x[1]); });
    return out;
  }
  function syncProps() {
    var v = current(), form = root.querySelector('[data-srp-form]'); if (!v || !form) return;
    var box = form.querySelector('[data-srp-props]');
    if (!box) { box = document.createElement('div'); box.setAttribute('data-srp-props', ''); box.hidden = true; form.appendChild(box); }
    var rows = orderProps(v);
    box.innerHTML = rows.map(function (r) { return '<input type="hidden" name="properties[' + r[0].replace(/[\[\]"]/g, '') + ']" value="' + r[1].replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '">'; }).join('');
  }
  window.__srpOrderProps = function () { var o = {}; try { orderProps(current()).forEach(function (r) { o[r[0].replace(/[\[\]"]/g, '')] = r[1]; }); } catch (e) {} return o; };
  var basis = root.querySelector('[data-srp-basis]');
  if (!basis) return;
  var busy = false;
  function fix() {
    if (busy) return;
    var n = packOf(current()), multi = BUNDLE || n > 1;
    var txt = basis.textContent || '';
    var parts = txt.split(' · ');
    var head = BUNDLE ? 'price for the complete bundle' : 'price for the complete pack of ' + n + ' ' + word(n);
    if (multi && parts[0] !== head) {
      parts[0] = head;
      busy = true; basis.textContent = parts.join(' · '); busy = false;
    }
    var note = root.querySelector('[data-srp-packnote]');
    if (!note && multi) {
      var act = root.querySelector('.srp-actions');
      if (act) {
        note = document.createElement('p');
        note.setAttribute('data-srp-packnote', '');
        note.style.cssText = 'margin:10px 0 0;font-size:15px;font-weight:600;color:#0E1A2B';
        act.parentNode.insertBefore(note, act.nextSibling);
      }
    }
    try { drawSpec(); } catch (e) {}
    try { syncProps(); } catch (e) {}
    if (note) {
      note.hidden = !multi;
      note.textContent = BUNDLE ? 'Quantity 1 = 1 complete bundle.' : 'Quantity 1 = 1 complete pack of ' + n + ' ' + word(n) + '.';
    }
  }
  new MutationObserver(fix).observe(basis, { childList: true, characterData: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  window.addEventListener('load', fix);
})();
